// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","EPGButton":"_6X8Uzb","icon":"_1ie7Rq","fadeInFrames":"_3BHx_B"};